module.exports = __webpack_public_path__ + "img/right_md_1.d6e5db28.jpg";